/* eslint-disable no-unused-vars */
// import { Col, Row } from 'antd';
// import { Content } from 'antd/lib/layout/layout';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import { useDispatch } from 'react-redux';
import { DokanButtons } from '../../components/button/DokanButtons';
import DokanExportImportButton from '../../components/button/DokanExportImportButton';
import DokanModal from '../../components/modal/DokanModal';
import DokanPageTitle from '../../components/text/DokanPageTitle';
import ProductTable from './ProductTable';
import ProductTableFilters from './ProductTableFilters';
import DokanAlert from '../../components/shared/Alert';
import { dismissAlert } from '../../redux/alerts/alertsActions';
import { resetProductForm } from '../../redux/products/productsActions';
import ProductFilters from './ProductFilters';

function Products() {
    const { push } = useHistory();
    const [visible, setVisible] = useState(false);
    const dispatch = useDispatch();
    const addNewProduct = () => {
        dispatch(resetProductForm());
        push('/products/create');
    };

    useEffect(() => {
        dispatch(dismissAlert());
    }, [dispatch]);

    return (
        <div className="container mx-auto md:px-10 md:py-12">
            {/* <Button type="primary" onClick={() => setVisible(true)}>
                Open Modal of 1000px width
            </Button>
            <DokanModal visible={visible} setVisible={setVisible} /> */}
            <div className="dokan-flex-between">
                <div>
                    <DokanPageTitle>Products</DokanPageTitle>
                </div>
                <div>
                    <div className="flex">
                        <div>
                            <DokanExportImportButton />
                        </div>
                        <div>
                            <DokanButtons
                                variant="primary"
                                buttonStyle="ml-20px"
                                onClick={() => addNewProduct()}
                            >
                                + Add New Product
                            </DokanButtons>
                        </div>
                    </div>
                </div>
            </div>
            <DokanAlert />
            <div className="flex flex-col">
                <div className="mt-40px">
                    <ProductFilters />
                    {/* <ProductTableFilters /> */}
                </div>
                <div className="mt-35px">
                    <ProductTable />
                </div>
            </div>
        </div>
    );
}

export default Products;
